import { useMutation, useQueryClient } from '@tanstack/react-query'
import type {
  AgentAgentKYCStartInput,
  AgentAddAgentDocumentInput,
} from '../api'
import type { IMutationArgs } from '../types'
import kycService from './agent-kyc.service'
import { EAgentAuthQueryKey } from '../agent-auth'

export const useAgentStartVideoKyc = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: AgentAgentKYCStartInput) =>
      kycService.agentStartVideoKyc(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EAgentAuthQueryKey.AGENT_AUTH_DETAILS],
        })
      return data
    },
  })
}

export const useAgentAddKycDocument = (args: IMutationArgs) => {
  const queryClient = useQueryClient()
  const { invalidate } = args
  return useMutation({
    mutationFn: (data: AgentAddAgentDocumentInput) =>
      kycService.agentAddKycDocument(data),
    onSuccess: (data) => {
      if (invalidate)
        queryClient.invalidateQueries({
          queryKey: [EAgentAuthQueryKey.AGENT_AUTH_DETAILS],
        })
      return data
    },
  })
}
